export default __webpack_public_path__ + "static/media/mark-as-finished-flag.f78b4459.svg";